











































import Vue from 'vue'

export default Vue.extend({
  name: 'ClaimInfoModal',

  components: {},

  props: {
    brand: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      curSlideNum: 0,
      slides: [
        {
          slideNum: 1,
          title: 'Visit the busines and redeem your offer',
          bottomInstructions: 'Go to brand use the special voucher we provide you after accepting this offer.',
          imageUrl: 'instructions_01.svg',
        },
        {
          slideNum: 2,
          title: 'Take a photo and post it to social media or a review',
          bottomInstructions: "Take a photo of what you're getting or you and your friends enjoying yourselves at brand and post it.",
          imageUrl: 'instructions_02.svg',
        },
        {
          slideNum: 3,
          title: 'Upload a screenshot & submit it to the business',
          bottomInstructions: 'Take a screenshot of your review or social post and submit it to brand.',
          imageUrl: 'instructions_03.svg',
        },
        {
          slideNum: 4,
          title: 'Help local business and get rewarded',
          bottomInstructions:
            'Local businesses need your help! Businesses are happy to reward you for sharing your experience online with your friends and family',
          imageUrl: 'instructions_04.svg',
        },
      ],
    }
  },

  methods: {
    closeDialog() {
      this.$emit('claim-info-modal-close')
    },
    nextSlide() {
      if (this.curSlideNum === 3) {
        this.$emit('claim-info-modal-close')
      }
      this.$refs.carousel.next()
    },
  },
})
